export default "__VITE_ASSET__D0npbJ7x__"